import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { LinearProgress, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useIntl } from "react-intl";
import ButtonComponent from "./common/ButtonComponent";
import { useDispatch, useSelector } from "react-redux";
import { selectRemainingProductsModal } from "store/product-list/ProductListSelectors";
import { cancelLoadRemainingProducts as cancelAction } from "store/product-list/ProductListActions";

const StyledBox = styled(Box)({
  marginBottom: "16px",
});

const ProgressContainer = styled(Box)({
  width: "100%",
  marginBottom: "16px",
});

const StyledLinearProgress = styled(LinearProgress)({
  height: 8,
  borderRadius: 4,
});

const CenteredTypography = styled(Typography)({
  textAlign: "center",
});

const RemainingProductsLoadingModal: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const modalState = useSelector(selectRemainingProductsModal);

  const handleCancel = () => {
    dispatch(cancelAction());
  };

  if (!modalState.isOpen) {
    return null;
  }

  const progressPercentage =
    modalState.total > 0
      ? Math.round((modalState.loaded / modalState.total) * 100)
      : 0;

  return (
    <Dialog
      open={modalState.isOpen}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={false}
    >
      <DialogTitle>
        {intl.formatMessage({
          id: "remainingProductsModal.title",
          defaultMessage: "Preview Loading",
        })}
      </DialogTitle>
      <DialogContent>
        <StyledBox>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {intl.formatMessage(
              {
                id: "remainingProductsModal.progress",
                defaultMessage:
                  "Loading {loaded} of {total} remaining products...",
              },
              {
                loaded: modalState.loaded,
                total: modalState.total,
              },
            )}
          </Typography>
        </StyledBox>
        <ProgressContainer>
          <StyledLinearProgress
            variant="determinate"
            value={progressPercentage}
          />
        </ProgressContainer>
        <CenteredTypography variant="body2" color="text.secondary">
          {progressPercentage}%
        </CenteredTypography>
      </DialogContent>
      <DialogActions>
        <ButtonComponent
          color="secondaryButtonColorCTABlue"
          variant="outlined"
          onClick={handleCancel}
        >
          {intl.formatMessage({
            id: "general.cancel",
            defaultMessage: "Cancel",
          })}
        </ButtonComponent>
      </DialogActions>
    </Dialog>
  );
};

export default RemainingProductsLoadingModal;
